import { ValidationError } from '@/types/validation';
import { createContext } from 'react';

type ErrorContextType = {
  errors: ValidationError[];
  setErrors: (errors: ValidationError[]) => void;
};

export const ErrorContext = createContext<ErrorContextType>({
  errors: [],
  setErrors: () => {}
});
